import styled from 'styled-components';

export const TypeAction = styled.div`
  display: inline-block;
  align-items: center;
  margin-bottom: 16px;
  & > :not(:last-child) {
    margin-right: 8px;
  }
  button {
    min-height: unset;
  }
  div.intro {
    font-size: 14px;
    line-height: 14px;
    color: #12344d;
  }
`;

export const ConditionButton = styled.div`
  padding: 8px 12px;
  background: #ebf0fc;
  border: 1px solid #c6cfe3;
  border-radius: 4px;
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  color: #183247;
  margin: 10px;
  width: fit-content;
`;

export const SegmentRuleContainer = styled.div``;

export const SegmentConditionBox = styled.div<{ isErrored?: boolean }>`
  background: #ffffff;
  border: 1px solid
    ${({ isErrored }) => (isErrored ? 'var(--text-danger)' : '#f2f2f2')};
  box-shadow: inset 0px 1px 2px rgba(18, 52, 77, 0.08);
  border-radius: 4px;
  padding: 12px;
`;

export const ConditionRowContainer = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  margin-bottom: 12px;
  & > span.icon {
    width: 24px;
    cursor: pointer;
    padding: 2px 6px;
  }
  .dropdown-status {
    margin-left: 8px;
  }
  button {
    .dropdown-status {
      margin-top: 4px;
    }
  }
  & > :not(:last-child) {
    margin-right: 6px;
  }

  div[role='combobox'] input {
    width: 100%;
    text-overflow: ellipsis;

    & + .clear-icon-container {
      display: none;
    }
  }

  input {
    min-width: unset;
  }
  .input-basic {
    input[type='datetime-local'] {
      width: 230px;
    }
    input[type='number'] {
      width: 100px;
    }
    input[type='text'] {
      width: 100px;
      height: 36px;
    }
  }
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
